module.exports = "https://www.gc-qa.gnp.com.mx/c14cc5f8a6931a83cb4b14e12c3fb9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/05.png
// module id = 999
// module chunks = 0 1